var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trp-percentage-bar"},[_c('div',{staticClass:"trp-percentage-bar-inner",style:({ width: _vm.getPercentage() })}),_vm._v(" "),_c('div',{staticClass:"trp-filled-area",style:({ width: _vm.getPercentage() })})])}
var staticRenderFns = []

export { render, staticRenderFns }